import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DeliveryMethodState {
  selectedDeliveryMethod: {
    id: number;
    name: string;
    estimatedDays?: string;
  } | null;
}

const initialState: DeliveryMethodState = {
  selectedDeliveryMethod: null,
};

const deliveryMethodSlice = createSlice({
  name: "deliveryMethod",
  initialState,
  reducers: {
    setDeliveryMethod: (
      state,
      action: PayloadAction<DeliveryMethodState["selectedDeliveryMethod"]>
    ) => {
      state.selectedDeliveryMethod = action.payload;
    },
    clearDeliveryMethod: (state) => {
      state.selectedDeliveryMethod = null;
    },
  },
});

export const { setDeliveryMethod, clearDeliveryMethod } =
  deliveryMethodSlice.actions;
export default deliveryMethodSlice.reducer;
